export default __webpack_public_path__ + "static/media/phone-call.6e142172.png";